import { Directive } from '@angular/core';
import { PhxContextService } from '../../services/phx-context-service';
import { PhxSortItemService } from '../../services/phx-sort-item-service';

@Directive({
  selector: '[phx-sort-item]',
  providers: [
    { provide: PhxContextService, useClass: PhxSortItemService },
  ]
})
export class PhxSortItemDirective  {
  constructor() {
  }
}
